import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {FileActivityModel, FileModel, FolderModel} from '@/libs/Api';
import {StoreName} from '@/libs/core/store/store-name';
import { FilesDataService } from '../files-data-service';
import { FileActivitiesDataService } from '../file-activities-data-service';
import {FoldersDataService} from '@/libs/files/folders-data-service';

export const foldersStore = registerCrudStore<FolderModel, FolderModel>(StoreName.Folder, new FoldersDataService());
export const filesStore = registerCrudStore<FileModel, FileModel>(StoreName.File, new FilesDataService());
export const fileActivitiesStore = registerCrudStore<FileActivityModel, FileActivityModel>(StoreName.FileActivity, new FileActivitiesDataService());
